import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getFormFieldsForChannel } from "../utils/formFieldsConfig";

export const useChannelTypes = () => {
  const [channelTypes, setChannelTypes] = useState({});
  
  // Add a check to prevent accessing undefined properties
  const serviceableChannels = useSelector((state) => 
    state?.app?.appData?.channels || []
  );

  useEffect(() => {
    // Only process if serviceableChannels is an array
    if (!Array.isArray(serviceableChannels)) {
      return;
    }

    const initialChannelTypes = {};

    serviceableChannels.forEach((channel) => {
      if (!channel || !channel.slug) return;
      
      initialChannelTypes[channel.slug] = {
        id: channel.slug,
        _id: channel._id,
        name: channel.name,
        icon: channel.logoUrl,
        isServiceable: channel.isActive,
        formFields: getFormFieldsForChannel(channel.slug),
      };
    });

    setChannelTypes(initialChannelTypes);
  }, [serviceableChannels]);

  return channelTypes;
};